import { StandardDialog } from "@roc/ui";
import { normalizeAmount } from '@roc/feature-utils';
import { makeStyles, Typography, Table, TableRow, TableCell, TableHead, TableBody, Box } from "@material-ui/core";

const styles = makeStyles(() => ({
  guidelineParagraph: {
    paddingBottom: '10px',
  },
}));

const exhibitALoanSubtypes = [
  'Rental Portfolios'
];


const LoanTable = ({ data }) => {
  return (
    <Table>
      <TableRow>
        <TableCell>Loan #:</TableCell>
        <TableCell>{data?.loanId}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Loan Amount:</TableCell>
        <TableCell>{normalizeAmount(data?.loanAmount)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Borrower Entity:</TableCell>
        <TableCell>{data?.borrowerEntity}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Property Type:</TableCell>
        <TableCell>{data?.propertyType}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Property Address(es):</TableCell>
        <TableCell>{data?.propertyAddress}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Property Replacement Cost:</TableCell>
        <TableCell>{normalizeAmount(data?.propertyReplacementCost)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Annual Rental Income:</TableCell>
        <TableCell>{normalizeAmount(data?.annualRentalIncome)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell>
          {'Is any portion of the property in a High Hazard \nFlood Zone as determined by FEMA?:'}
        </TableCell>
        <TableCell>
          {data?.floodzone}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>
          Servicer assigned
        </TableCell>
        <TableCell>
          {data?.servicer}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>
          Servicer Address
        </TableCell>
        <TableCell>
          {data?.servicerDetail}
        </TableCell>
      </TableRow>
    </Table>)
}


const LoanTableWithExhibitA = ({ data }) => {
  return (
    <>
      <Table>
        <TableRow>
          <TableCell>Loan #:</TableCell>
          <TableCell>{data?.loanId}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Loan Amount:</TableCell>
          <TableCell>{normalizeAmount(data?.loanAmount)}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Borrower Entity:</TableCell>
          <TableCell>{data?.borrowerEntity}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Property Type:</TableCell>
          <TableCell>Please refer to Exhibit A</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Property Address(es):</TableCell>
          <TableCell>Please refer to Exhibit A</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Property Replacement Cost:</TableCell>
          <TableCell>Please refer to Exhibit A</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Annual Rental Income:</TableCell>
          <TableCell>Please refer to Exhibit A</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            {'Is any portion of the property in a High Hazard \nFlood Zone as determined by FEMA?:'}
          </TableCell>
          <TableCell>
            {data?.floodzone}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            Servicer assigned
          </TableCell>
          <TableCell>
            {data?.servicer}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            Servicer Address
          </TableCell>
          <TableCell>
            {data?.servicerDetail}
          </TableCell>
        </TableRow>
      </Table>
      {/* Exhibit A section */}
      {data?.properties?.length > 0 && (
        <>
          <Typography variant="h6" style={{ marginTop: 20 }}>Exhibit A</Typography>

          <Box style={{ overflowX: 'auto', maxWidth: '100%', marginBottom: '45px' }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell><strong>Address</strong></TableCell>
                  <TableCell><strong>Property Type</strong></TableCell>
                  <TableCell><strong>Allocated Loan Amount</strong></TableCell>
                  <TableCell><strong>Replacement Cost</strong></TableCell>
                  <TableCell><strong>Annual Rental Income</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.properties.map((property, index) => (
                  <TableRow key={index}>
                    <TableCell>{property?.fullPropertyAddress}</TableCell>
                    <TableCell>{property?.propertyType}</TableCell>
                    <TableCell>{normalizeAmount(property?.allocatedLoanAmount)}</TableCell>
                    <TableCell>{normalizeAmount(property?.propertyReplacementCost)}</TableCell>
                    <TableCell>{normalizeAmount(property?.annualRentalIncome)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </>
      )}
    </>
  );
};



export const InsuranceGuidelinesModal = ({ open, onClose, data }: { open: boolean, onClose: () => void, data: any }) => {
  const classes = styles();
  console.log('insurance Guide line modal open')
  return (
    <StandardDialog
      open={open}
      title="Third-Party Insurance Approval Instructions"
      maxWidth="lg"
      handleClose={onClose}
      dialogContent={
        <>
          <Typography className={classes.guidelineParagraph}>
            Before closing, you must obtain an insurance policy that meets the lender insurance requirements.
          </Typography>

          <Typography className={classes.guidelineParagraph}>
            Our insurance consultant will review any policy submitted with a third-party insurance agent/carrier and confirm it complies with the guidelines. Borrowers must submit an ACORD form for review to ensure the policy complies.
          </Typography>

          <Typography className={classes.guidelineParagraph}>
            Below is information about the requirements for this particular loan. Please reach out to the insurance consultant with any questions.
          </Typography>
          {exhibitALoanSubtypes.includes(data?.loanSubtype) ? <LoanTableWithExhibitA data={data} /> : <LoanTable data={data} />}
        </>}
    />)
}